import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { useUserInfo } from '@src/hooks/useUserInfo';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { storage } from '@uhg-abyss/web/tools/storage';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { globalCss } from '@uhg-abyss/web/tools/styled';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useSelector } from 'react-redux';
import { styled } from '@uhg-abyss/web/tools/styled';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { useGetCredentials } from '@src/hooks/useGetCredentials';
import { StyledMarkdownLink } from '@src/common/StyledMarkdownLink';
import { OrganizationApi } from './OrganizationApi';
import { Resources } from './Resources';
import { constants } from '@src/common/Utils/Constants';
import { SubscribeToAPIModal } from '@src/common/SubscribeToAPIModal';
import { useHolidayApi } from '@src/hooks/useHolidayApi';
import { CommonAlert } from '@src/common/Alert/CommonAlert';
import { TouModal } from './TouModal';
import { useGetUserAcceptanceTOU } from '@src/hooks/useGetUserAcceptanceTOU';
import { LagoonContext } from '@src/AppContext';
import { SecretExpireModalV2 } from './CredentialsV2/SecretExpireModalV2';
import { APIsCategoryLagoon } from '@src/common/APIsCategoryLagoon/APIsCategoryLagoon';

const Wrapper = styled('div', {
  '.abyss-alert-root': {
    marginBottom: '20px',
  },

  '@screen >= $xs': {
    padding: '44px',
  },

  '@screen >= $xl': {
    padding: '32px 0 0 0',
  },
});

const PageHeading = styled('h1', {
  color: 'rgb(0, 38, 119)',
  fontSize: '46px',
  fontStyle: 'normal',
  lineHeight: '56px',
  letterSpacing: '0px',
  textAlign: 'left',
});

const StyledFlex = styled('div', {
  display: 'flex',
  flexBasis: '75%',
  marginTop: '32px',
});

const PageHeadingContainer = styled('div', {
  marginTop: '122',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
});

const AlertHeadertyled = globalCss({
  '.abyss-alert-title': {
    fontWeight: '700 !important',
    fontSize: '14px !important',
    lineHeight: '24px !important',
  },
  '.abyss-alert-inline-text': {
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lineHeight: '24px !important',
  },
});

const HeaderResponsiveDiv = styled('div', {
  display: 'block',
});

const APIAlertNameStyle = styled('p', {
  marginBottom: '0px !important',
});

export const Welcome = () => {
  const [isPageLoadTriggered, setIsPageLoadTriggered] = useState(false);
  const [showSecretExpireModal, setShowSecretExpireModal] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const lagoonContext = React.useContext(LagoonContext);
  const contentManagement = lagoonContext?.getTable('alerts').getRow();
  const alertList = contentManagement;
  const alerts =
    alertList?.length > 0
      ? alertList?.filter((el) => {
          return el.active;
        })
      : null;
  const { navigate } = useRouter();
  const dsUserInfo = useSelector((state) => {
    return state.GET_DS_USER_INFO;
  });
  const [, getUserInfo] = useUserInfo();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const healthCheckApiData = useSelector((state) => {
    return state.GET_API_HEALTH_CHECK;
  });
  const [, setHolidayDate] = useHolidayApi();
  const [showSubscribeAPIModal, setShowSubscribeAPIModal] = useState(false);
  const [runCredentials, setRunCredentials] = useState(false);
  // const [userStatus, getUserStatus] = useUserStatus();
  const [credentials, getCredentials] = useGetCredentials();
  const [dsApiAssociatedLength, setDsApiAssociatedLength] = useState(0);
  const cards = lagoonContext?.getTable('browse-apis-v2').getRow();
  const cardList = cards?.filter((card) => {
    return card.active;
  });
  const featureToggles = lagoonContext?.getTable('feature-toggles');
  const priorAuthToggle = featureToggles?.getRow('PRIOR_AUTH_TOGGLE')?.enabled;
  const [showTouModal, setShowTouModal] = useState(false);
  const [userAcceptanceTOU, getUserAcceptanceTOU] = useGetUserAcceptanceTOU();
  let outageAlertMessage;
  let alertApiName;

  const getAlertByType = (alertType) => {
    return alerts?.length > 0
      ? alerts?.filter((el) => {
          return el.alertType === alertType;
        })
      : [];
  };

  useEffect(() => {
    const isAccepted = userAcceptanceTOU?.data?.accepted;
    setShowTouModal(false);
    if (
      userAcceptanceTOU?.error ||
      (!userAcceptanceTOU?.loading && userAcceptanceTOU?.data)
    ) {
      setShowTouModal(!isAccepted || userAcceptanceTOU?.error);
    }
  }, [userAcceptanceTOU]);

  const releaseNotesAlertList = getAlertByType(
    'welcome-page-marketplace-update'
  );

  const releaseNotesAlert =
    releaseNotesAlertList && releaseNotesAlertList.length
      ? releaseNotesAlertList[0]
      : null;

  useEffect(() => {
    if (!document.getElementById('auth-script')) {
      const script = document.createElement('script');

      script.src = config('UHC_AUTH_SCRIPT');
      script.async = false;
      script.id = 'auth-script';

      document.head.appendChild(script);
    }

    if (!userInfo.uuid) {
      getUserInfo();
    }
  }, []);

  useEffect(() => {
    if (
      runCredentials &&
      !credentials?.loading &&
      !credentials?.data?.stage?.clientId
    ) {
      const orgId = dsUserInfo?.data?.orgId;
      // getUserStatus({ userInfo, orgId });
      getCredentials({ userInfo, orgId });
      setRunCredentials(false);
    }

    if (credentials?.data) {
      const credentialExpiryChecked = sessionStorage.getItem(
        'SECRET_EXPIRY_CHECKED'
      );
      const stageAlert =
        credentials?.data?.stage?.secrets?.filter((secret) => {
          return secret.expiresInDays !== null && secret.expiresInDays <= 30;
        }).length > 0;
      const prodAlert =
        credentials?.data?.prod?.secrets?.filter((secret) => {
          return secret.expiresInDays !== null && secret.expiresInDays <= 30;
        }).length > 0;
      if (!credentialExpiryChecked && (stageAlert || prodAlert)) {
        setShowSecretExpireModal(true);
        sessionStorage.setItem('SECRET_EXPIRY_CHECKED', true);
      }
    }
  }, [credentials, runCredentials]);

  useEffect(() => {
    if (dsUserInfo?.data?.uuid) {
      setRunCredentials(true);
    }
    if (
      !dsUserInfo.loading &&
      !isPageLoadTriggered &&
      userInfo.uuid &&
      (dsUserInfo?.data?.uuid || dsUserInfo?.data?.status === 'notprovisioned')
    ) {
      setIsPageLoadTriggered(true);
      setHolidayDate({ userInfo });
      event('NEW_PAGE_LOAD', {
        pageName: 'apimarketplace:welcome',
        siteSectionL1: 'welcome',
        dsUserInfo: dsUserInfo.data,
        userInfo,
      });
      storage.local.set('IS_SIGN_IN_CLICKED', false);
    }
  }, [isPageLoadTriggered, dsUserInfo, userInfo]);

  useEffect(() => {
    if (userInfo.uuid) {
      getUserAcceptanceTOU({ userInfo });
    }
  }, [userInfo]);

  const addDataIntoStorage = () => {
    storage.local.set(constants.LAST_VIEWED_DATE, +new Date());
  };

  const getAlertDateValue = () => {
    let updatedDate = releaseNotesAlert ? releaseNotesAlert.date : '';
    updatedDate = new Date(updatedDate);
    const viwedDate = storage.local.get(constants.LAST_VIEWED_DATE);
    return !(viwedDate && viwedDate > updatedDate);
  };

  const errorAlertVisibility = () => {
    return !!(
      dsUserInfo?.data?.linkedApis?.prod?.length > 0 &&
      !dsUserInfo.data?.linkedApis?.stage
    );
  };

  const getStageAndProdApis = (userOrgInfo) => {
    return {
      stageApis: userOrgInfo.linkedApis?.stage || [],
      prodApis: userOrgInfo.linkedApis?.prod || [],
    };
  };

  const apiDataList = (apisList, env) => {
    return apisList?.length > 0
      ? apisList.filter((item) => {
          const api = healthCheckApiData?.data?.[env]?.[item];
          return api && api !== 200;
        })
      : [];
  };

  const API_OUTAGE_BOTH = 'api-outage-both';
  const MULTIPLE_OUTAGE_ALERT = 'multiple-outage-alert';
  const API_OUTAGE_STAGE = 'api-outage-stage';
  const API_OUTAGE_PROD = 'api-outage-prod';

  const outageAlertVisibility = () => {
    const { stageApis, prodApis } = getStageAndProdApis(dsUserInfo.data);

    const stageDataList = apiDataList(stageApis, 'stage');
    const prodDataList = apiDataList(prodApis, 'prod');

    // Multiple alerts on stage and prod
    if (stageDataList?.length > 0 && prodDataList?.length > 0) {
      // more then 1 alert in both
      if (stageDataList.length > 1 || prodDataList?.length > 1) {
        outageAlertMessage = getAlertByType(MULTIPLE_OUTAGE_ALERT);
      } else if (stageDataList[0] === prodDataList[0]) {
        // only 1 alert in both
        outageAlertMessage = getAlertByType(API_OUTAGE_BOTH);
        [alertApiName] = stageDataList;
      } else {
        outageAlertMessage = getAlertByType(MULTIPLE_OUTAGE_ALERT);
      }
      return true;
    }

    // Single alerts on stage
    if (stageDataList?.length > 0) {
      if (stageDataList?.length > 1) {
        outageAlertMessage = getAlertByType(MULTIPLE_OUTAGE_ALERT);
        return true;
      }
      outageAlertMessage = getAlertByType(API_OUTAGE_STAGE);
      [alertApiName] = stageDataList;
      return true;
    }

    // Single alerts on prod
    if (prodDataList?.length > 0) {
      if (prodDataList?.length > 1) {
        outageAlertMessage = getAlertByType(MULTIPLE_OUTAGE_ALERT);
        return true;
      }
      outageAlertMessage = getAlertByType(API_OUTAGE_PROD);
      [alertApiName] = prodDataList;
      return true;
    }
    return false;
  };

  const onAlertRouting = () => {
    navigate(releaseNotesAlert?.buttonLink);
    storage.local.set(constants.LAST_VIEWED_DATE, +new Date());
  };

  const getAlertMessage = () => {
    return (
      <React.Fragment>
        {releaseNotesAlert?.alertMessage && (
          <Markdown
            id="marketplace-alert-text"
            options={{
              overrides: {
                a: StyledMarkdownLink,
              },
            }}
          >
            {releaseNotesAlert.alertMessage}
          </Markdown>
        )}
      </React.Fragment>
    );
  };

  const getOutageAlertMessage = () => {
    return (
      <HeaderResponsiveDiv>
        <APIAlertNameStyle>
          {alertApiName !== '' && alertApiName}
          {outageAlertMessage?.length > 0 && (
            <Markdown id="marketplace-outage-alert-text">
              {outageAlertMessage[0].alertMessage}
            </Markdown>
          )}
        </APIAlertNameStyle>
      </HeaderResponsiveDiv>
    );
  };

  const findLength = (linkedApis) => {
    let flag = false;
    let length = 0;

    linkedApis.forEach((api) => {
      if (constants.SUPER_CONNECTOR_APIS.includes(api)) {
        if (!flag) {
          length += 1;
          flag = true;
        }
        // Skip counting Super Connector APIs more than once
      } else {
        length += 1;
      }
    });

    return length;
  };

  const linkedApisLength =
    dsUserInfo?.data?.linkedApis?.stage?.length > 0
      ? findLength(dsUserInfo?.data?.linkedApis?.stage)
      : 0;
  useEffect(() => {
    let finalLength = linkedApisLength;
    if (
      !priorAuthToggle &&
      dsUserInfo?.data?.linkedApis?.stage?.includes('PriorAuth')
    ) {
      finalLength = linkedApisLength - 1;
    }
    setDsApiAssociatedLength(finalLength);
  }, [dsUserInfo]);
  AlertHeadertyled();
  return (
    <React.Fragment>
      <TouModal showTouModal={showTouModal} setShowTouModal={setShowTouModal} />
      <SecretExpireModalV2
        showModal={showSecretExpireModal}
        modalOnClose={setShowSecretExpireModal}
      />
      <SubscribeToAPIModal
        showModal={showSubscribeAPIModal}
        modalOnClose={setShowSubscribeAPIModal}
      />
      <Wrapper>
        <CommonAlert alertType="dashboard" />
        <Alert
          title="API Outage"
          variant="warning"
          isVisible={outageAlertVisibility()}
          inlineText={getOutageAlertMessage()}
        />
        <Alert
          title=""
          variant="error"
          isVisible={errorAlertVisibility()}
          inlineText="There seems to be an error with your credentials, please contact your API Consultant immediately."
        />
        {userInfo?.firstName !== '' ? (
          <React.Fragment>
            {getAlertDateValue() && releaseNotesAlert && (
              <React.Fragment>
                {/* <AlertHeadertyled /> */}
                <Alert
                  title="Marketplace Update"
                  variant="info"
                  onAction={() => {
                    setIsVisible(false);
                    onAlertRouting();
                  }}
                  actionText={releaseNotesAlert?.buttonText}
                  inlineText={getAlertMessage()}
                  isVisible={isVisible}
                  onClose={() => {
                    setIsVisible(false);
                    addDataIntoStorage();
                  }}
                />
              </React.Fragment>
            )}
            <StyledFlex>
              <PageHeadingContainer style={{ marginTop: '-10px' }}>
                <PageHeading
                  id="welcome-user"
                  style={{
                    fontSize: '46px',
                    marginTop: '0',
                    marginBottom: '0px',
                  }}
                >
                  Welcome {userInfo.firstName}
                </PageHeading>
              </PageHeadingContainer>
            </StyledFlex>
          </React.Fragment>
        ) : (
          <LoadingOverlay
            loadingTitle="Signing In"
            ariaLoadingLabel="Signing In"
            isLoading
          />
        )}
        <OrganizationApi />
        {cardList?.length > dsApiAssociatedLength && (
          <APIsCategoryLagoon isBrowseApi={true} />
        )}
        <Resources />
      </Wrapper>
    </React.Fragment>
  );
};
